export default "__VITE_ASSET__06905e72__"